const Slider = require('./slider-class.js');
const Utils = require('core-helpers/utils.js');

(function(root, doc, undefined) {
    const sliders = Utils.getElementsByClass('js-slider');

    sliders.forEach(item => new Slider(item));

})(window, document);
